module.exports = __webpack_public_path__ + "img/IconSuiteBranco.e49add19.png";